import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./routes/Home";
import RankPrediction from "./routes/RankPrediction";
import MatchPrediction from "./routes/MatchPrediction";
import Simulation from "./routes/Simulation";
import Articles from "./routes/Articles";
import { TimezoneProvider } from "./global/timezone";
import LanguageRedirect from "./component/LanguageRedirect";

function App() {
  return (
    <TimezoneProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LanguageRedirect />} />
          <Route path="/:language" element={<Home />} />
          <Route
            path="/:language/rank_prediction/:league"
            element={<RankPrediction />}
          />
          <Route
            path="/:language/match_prediction/:league"
            element={<MatchPrediction />}
          />
          <Route path="/:language/articles" element={<Articles />} />
					<Route
						path="/:language/simulation/"
						element={<Simulation />}
					/>
        </Routes>
      </Router>
    </TimezoneProvider>
  );
}

export default App;
